module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 146.86802494.png";